import { render, staticRenderFns } from "./CmgLeaveGroupOrderModal.vue?vue&type=template&id=018c95d6&scoped=true&lang=pug"
import script from "./cmg-leave-group-order-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leave-group-order-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaveGroupOrderModal.vue?vue&type=style&index=0&id=018c95d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c95d6",
  null
  
)

export default component.exports